import React from 'react'
import UserManageMentDetails from '../components/userManagement/UserManageMentDetails'

const UserManagementDetailPage = () => {
    return (
        <div className='outletConainer'>
            <UserManageMentDetails />
        </div>
    )
}

export default UserManagementDetailPage
